import { env_core } from "./envs/env.core"
import { env_dev } from "./envs/env.dev"
import { env_test } from "./envs/env.test"
import { env_prod } from "./envs/env.prod"
type uType = typeof env_core & typeof env_dev & typeof env_test & typeof env_prod;

//系统环境变量定义
let environments: uType | undefined;

try {
    if (ENV_IS_TEST_MODE) {
        environments = {
            ...env_core,
            ...env_test
        }
    }

    if (ENV_IS_PROD_MODE) {
        environments = {
            ...env_core,
            ...env_prod
        }
    }
} catch (e) { }

if (environments == undefined) {
    environments = {
        ...env_core,
        ...env_dev
    }
}

let envConfig = environments as uType

export { envConfig }